import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { ApiService } from '../../service';

@Component({
  selector: 'app-id-proof',
  templateUrl: './id-proof.component.html',
  styleUrls: ['./id-proof.component.scss']
})
export class IdProofComponent implements OnInit {
  public qrdata: any;
  public myAngularxQrCode: string = null;
  screenData:any;
  userInfo: any;
  // _data = [{
  //   'name': 'Jolly',
  //   'address': 'Mars',
  //   'email': 'example@abc.com'
  // }]

  // dataString = JSON.stringify(this._data);

  constructor(public dialog: MatDialog, @Inject(MAT_DIALOG_DATA) public data: any,
  public dialogref: MatDialogRef<IdProofComponent>, public api: ApiService, private http: HttpClient) { 
    this.myAngularxQrCode = 'ItSoluionStuff.com';
    this.userInfo = JSON.parse(localStorage.getItem('vprpinfo'));
  }

  ngOnInit(): void {
    // console.log(`data`, this.data.data);
    this.getScreenData();
    const _data = {
      "pgmember_name":this.data.data.pgmember_name?this.data.data.pgmember_name:"-",
      "fatherhusband_name":this.data.data.fatherhusband_name?this.data.data.fatherhusband_name:"-",
      "panchayat_desc":this.data.data.panchayat_desc?this.data.data.panchayat_desc:"-",
      "village_desc":this.data.data.village_desc?this.data.data.village_desc:"-",
      "pg_name":this.data.data.pg_name?this.data.data.pg_name:"-",
      "mobile_no_active":this.data.data.mobile_no_active?this.data.data.mobile_no_active:"-",
      "pgmember_id":this.data.data.pgmember_id?this.data.data.pgmember_id:0,
      "mobile_no_alternative":this.data.data.mobile_no_alternative?this.data.data.mobile_no_alternative:"-",
    }
    this.qrdata = JSON.stringify(_data);
    

  }

  getScreenData(){
    const reqHeader = {
      "_user_code": this.userInfo.loginId,
      "_user_token": "",
      "_url": '/getScreendata',
      "_succ_msg": ""
    }
    this.http.post(`${environment.endpoint}/${'iudUsertoken'}`, JSON.stringify(reqHeader), { headers:          this.iudgetHeaders('/iudUsertoken') }).subscribe(async (res: any) => {
      if (res) {

    this.api.get(`/getScreendata?screenCode=${`W21IDFCXX`}@${res.myArrayList[0].map._user_token}`).subscribe((res: any) => {
      this.screenData = res;
    });
  }
});
  }
 iudgetHeaders(url) {
    let headerValue = {};
    const token = localStorage.getItem(`token`);
      headerValue =  {
        'Content-Type':  'application/json',
        'Content-Security-Policy': "default-src 'self'; style-src 'self' fonts.googleapis.com; font-src fonts.gstatic.com",
        'X-Tenant-Identifier': 'dynamic_lokos',
        'Authorization': token ? 'Bearer ' + token: '',
        'Cache-Control':  'no-cache, no-store, must-revalidate, post- check=0, pre-check=0',
        'Pragma': 'no-cache',
        'Expires': '0',
        // "Referrer-Policy": "no-referrer, strict-origin-when-cross-origin",
        // "Strict-Transport-Security": "max-age=63072000; includeSubDomains",
        // "X-Content-Type-Options": "nosniff",
        "X-Frame-Options": "DENY",
        // "X-XSS-Protection": "1; mode=block",
        '_url': url,
        '_user_token': '',
        'userCode': this.userInfo.loginId,
        'roleCode': '',
        'blockCode': '',
    }
      return new HttpHeaders(headerValue);
    }
}
